import React from "react";
import { View } from "react-native";
import { Text } from "../../Text";
import { aboutProductStyles as styles } from "./styles";
import { Product } from "@/app/types/product";

type AboutProductProps = {
  item: Product;
};

const AboutProduct = ({ item: { name } }: AboutProductProps) => {
  return (
    <View
      style={styles.container}
      accessibilityRole="header"
      testID="product-header"
    >
      <View style={styles.titleContainer}>
        <Text
          style={styles.itemTitle}
          accessibilityRole="text"
          accessibilityLabel={`Product name: ${name}`}
        >
          {name}
        </Text>
      </View>
    </View>
  );
};

export default AboutProduct;
